import { Menu } from '@mi-front/ui';
import {
  Close as CloseIcon,
  SkipNext as EndSelectionIcon,
  SkipPrevious as StartSelectionIcon,
} from '@mui/icons-material';
import noop from 'lodash/noop';
import { useIntl } from 'react-intl';

interface Props {
  readonly startSelection: null | (() => void);
  readonly endSelection: null | (() => void);
  readonly clear: null | (() => void);
}

export function TranscriptonMenuView(p: Props) {
  const { formatMessage } = useIntl();

  return (
    <Menu
      className="el-cursor-menu"
      actions={[
        {
          icon: <StartSelectionIcon />,
          onClick: p.startSelection || noop,
          tooltip: formatMessage({
            id: 'logger.streamScreen.cursorMenu.startSelection',
            defaultMessage: 'Iniciar selección aquí',
          }),
          enabled: !!p.startSelection,
        },
        {
          icon: <EndSelectionIcon />,
          onClick: p.endSelection || noop,
          tooltip: formatMessage({
            id: 'logger.streamScreen.cursorMenu.endSelection',
            defaultMessage: 'Finalizar selección aquí',
          }),
          enabled: !!p.endSelection,
        },
        {
          icon: <CloseIcon />,
          onClick: p.clear || noop,
          tooltip: formatMessage({
            id: 'logger.streamScreen.selectionMenu.unselect',
            defaultMessage: 'Deseleccionar',
          }),
          enabled: !!p.clear,
        },
      ]}
    />
  );
}
